import React, { useState } from 'react';
import { Col, Row } from 'react-grid-system';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useTheme } from 'styled-components';

import { useForm } from '../../../../hooks';
import { Button, Input } from '../../../../shared/Components';
import { loginSchema, LoginField } from '../../../../validations/login';
import { strings } from '../../../../strings';
import { GotivaLogoIcon, LoginCover, User, Password, Line } from '../../../../assets/LoginPage';
import { AbsoluteImage, CoverImg, Text } from '../../../../shared/Typhography';
import {
  InputForm,
  LoginContainer,
  LoginError,
  LoginForm,
  LoginFormContent,
} from '../../../../shared/Typhography/LoginStyledComponents';
import { auth } from '../../../../services/Firebase';

interface FormInputs {
  [LoginField.Email]: string;
  [LoginField.Password]: string;
}

const Login = () => {
  const [errorLogin, setErrorLogin] = useState(false);
  const { colors } = useTheme();

  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm<FormInputs>({
    schema: loginSchema,
  });

  const doLogin = handleSubmit(async (data: FormInputs) => {
    try {
      await signInWithEmailAndPassword(auth, data.email, data.password);
    } catch (error) {
      setErrorLogin(true);
    }
  });

  // Autologin on dev environment, must have login credentials defined in .env file.
  if (process.env.NODE_ENV === 'development' && Boolean(process.env.REACT_APP_AUTOLOGIN)) {
    if (process.env.REACT_APP_USER && process.env.REACT_APP_PASSWORD) {
      signInWithEmailAndPassword(auth, process.env.REACT_APP_USER, process.env.REACT_APP_PASSWORD)
        .then((response) => console.log(response))
        .catch((error) => console.error(error));
    }
  }

  return (
    <LoginContainer fluid>
      <Row>
        <Col lg={4} md={6} sm={12} style={{ padding: '0' }}>
          <CoverImg imageUrl={LoginCover}>
            <AbsoluteImage width={35} height={35} top={15} left={30} src={GotivaLogoIcon} />
            <LoginFormContent alignItems="center" flexDirection="column">
              <AbsoluteImage top={-10} left={-30} src={Line} />
              <Text weight="bold" size={1.4} color={colors.white}>
                {strings.loginPageArtistsTitle1}
              </Text>
              <Text weight="bold" size={1.4} color={colors.white}>
                {strings.loginPageArtistsTitle2}
              </Text>
              <Text color={colors.white} margin="20px" size={1.1}>
                {strings.sendPortfolioText}
              </Text>
              <Button variant="white" width={170} height={40}>
                {strings.sendEmailButton}
              </Button>
            </LoginFormContent>
          </CoverImg>
        </Col>
        <Col lg={8} md={6} sm={12} style={{ padding: '0' }}>
          <LoginForm>
            <h1>{strings.loginFormTitle}</h1>
            <InputForm onSubmit={doLogin}>
              <Input
                required
                placeholder={strings.email}
                name={LoginField.Email}
                control={control}
                error={errors[LoginField.Email]}
                width="520px"
                placeholderIcon={User}
                margin="0 0 10px 0"
              />
              {/* <Text size={0.8} position="absolute" top="55px" right="0" color={colors.purple}>
                {strings.forgotPassword}
              </Text> */}
              <Input
                required
                type="password"
                placeholder={strings.password}
                name={LoginField.Password}
                control={control}
                error={errors[LoginField.Password]}
                width="520px"
                placeholderIcon={Password}
                margin="0 0 10px 0"
              />
              {errorLogin && <LoginError>{strings.wrongEmailOrPassword}</LoginError>}
              <Button width={270} height={58} disabled={!isValid} type="submit">
                {strings.loginButton}
              </Button>
            </InputForm>
          </LoginForm>
        </Col>
      </Row>
    </LoginContainer>
  );
};

export default Login;
